import { Store } from 'vuex'
import createPersistedState from 'vuex-persistedstate'

const store = () => {
  return new Store({
    state: () => {
      return {
        user: {},
        messages: [],
      }
    },
    actions: {
      setUser: (context, payload) => {
        context.commit('setUser', payload)
      },
      setMessages: (context, payload) => {
        context.commit('setMessages', payload)
      },
    },
    mutations: {
      setUser: (state, payload) => {
        state.user = payload
      },
      setMessages: (state, payload) => {
        state.messages = payload
      },
    },
    getters: {
      getUser: state => {
        return state.user
      },
      getMessages: state => {
        return state.messages
      }
    },
    plugins: [
      createPersistedState(),
    ]
  })
}

export default store